<template lang="pug">
v-app
	v-card(v-if="name")
		v-app-bar(absolute dense dark color="orange")
			v-app-bar-nav-icon(@click="drawer=!drawer")
			b 台灣好行評鑑系統
			v-select(class="ml-6" label="年分" :items="yearOptions" item-text="text" item-value="value" v-model="selectedYear" dense hide-details style="max-width: 120px" placeholder="請選擇年分" v-if="role === 1 && showYearSelector")
			v-btn(icon small @click="openAddYearDialog" v-if="role === 1 && showYearSelector")
				v-icon mdi-plus
			v-spacer
			v-dialog(v-model="addYearDialog" max-width="400" persistent v-if="showYearSelector")
				v-card
					v-card-title 新增年分
					v-card-text
						v-text-field(v-model.number="newYear" label="年分" type="number" :rules="[v => !!v || '請輸入民國年分', v => v >= 90 && v <= 150 || '請輸入 90～150']")
					v-card-actions
						v-spacer
						v-btn(text @click="addYearDialog = false") 取消
						v-btn(color="primary" @click="addYear" :loading="addYearLoading") 確定
	v-navigation-drawer(app v-model="drawer" v-if="name" color="orange lighten-2" width="180")
		.d-flex.flex-column.align-center.py-4
			v-avatar(size="72")
				v-img(:src="img" max-width="100" contain)
			.title.white--text(v-if="name") {{name}}
		v-expansion-panels(flat).pa-1
			v-expansion-panel.orange.lighten-5(dense)
				v-expansion-panel-header.orange.lighten-4 會員中心
				v-expansion-panel-content
					//- v-btn(dark text block color="teal" to="/checkin" @mouseup="title='會員打卡'") 打卡
					v-btn(dark text block color="teal" to="/login" @click="logout") 登出
			//- v-expansion-panel.orange.lighten-5(dense v-if="auth.schedule")
			//- 	v-expansion-panel-header.orange.lighten-4 行事曆
			//- 	v-expansion-panel-content
			//- 		v-btn(dark text block color="teal" to="/schedule" @click="title='行事曆管理'") 行程管理
			v-expansion-panel.orange.lighten-5(dense v-if="role === 1")
				v-expansion-panel-header.orange.lighten-4 管理者
				v-expansion-panel-content
					v-btn(dark text block color="teal" to="/settings" @click="title='會員管理'") 會員管理
					v-btn(dark text block color="teal" to="/design" @click="title='問卷設計'") 問卷設計
			v-expansion-panel.orange.lighten-5(dense v-if="role === 1")
				v-expansion-panel-header.orange.lighten-4 瀏覽問卷
				v-expansion-panel-content
					v-btn(dark text block color="teal" to="/trace") 問卷追蹤
					v-btn(dark text block color="teal" to="/result") 問卷結果
			v-expansion-panel.orange.lighten-5(dense)
				v-expansion-panel-header.orange.lighten-4 填寫問卷
				v-expansion-panel-content
					v-btn(dark text block color="teal" to="/record") 我的紀錄
					v-btn(dark text block color="teal" to="/write") 開始填寫
	v-main(style="padding-top:48px").orange.lighten-5
		router-view
</template>
<script>
import { bus, db, auth } from './main';
import axios from 'axios';
import login from './pages/login';
import twbus from '@/assets/tw-bus2.png';

export default {
	name: 'App',
	components: { login },
	data() {
		return {
			name: null,
			img: twbus,
			drawer: false,
			role: null,
			title: '台灣好行評鑑',
			yearOptions: [],
			yearMap: [],
			newYear: null,
			addYearDialog: false,
			addYearLoading: false,
		};
	},
	computed: {
		isAdmin() {
			return this.role === 1;
		},
		isBrowse() {
			return this.role === 2;
		},
		// 判斷能顯示的路徑
		showYearSelector() {
			const path = this.$route.path;
			return path !== '/record' && path !== '/write';
		},
		selectedYear: {
			// 直接綁定selectedYear
			get() {
				return this.$store.state.selectedYear;
			},
			// 當選擇年分改變，更新selectedYear
			set(val) {
				this.$store.commit('setSelectedYear', val);
			}
		},
	},
	methods: {
		logout() {
			sessionStorage.removeItem('token');
			sessionStorage.removeItem('user');

			this.$store.commit('setUser', null);

			this.name = null;
			this.role = null;
			this.drawer = false;

			this.$router.replace('/login');
		},
		refreshState() {
			if (!sessionStorage.getItem('token')) {
				this.name = null;
				this.role = null;
				this.drawer = false;
				return;
			}
			
			const userStr = sessionStorage.getItem('user');
			if (userStr) {
				try {
					const userData = JSON.parse(userStr);
					this.name = userData.name;
					this.role = userData.role;
					
					this.$store.commit('setUser', userData);
					
					if (window.innerWidth > 768) this.drawer = true;

					if (this.role === 1) {
						this.loadYearList();
					}
				} catch (error) {
					console.error('解析用戶資料失敗:', error);
					this.logout();
				}
			} else {
				this.name = null;
				this.role = null;
				this.drawer = false;
			}
		},
		// 顯示年分
		async loadYearList() {
			const yearResponse = await axios.get('/api/Account/YearList');
				if (yearResponse.data.status && yearResponse.data.result) {
					this.yearOptions = yearResponse.data.result.map(item => ({
						text: item.year,
						value: item.year
					}));
					this.year = this.yearOptions;
				}
		},
		openAddYearDialog() {
			this.newYear = null;
			this.addYearDialog = true;
		},
		// 新增年分
		async addYear() {
			const rocYear = parseInt(this.newYear, 10);
			if (isNaN(rocYear) || rocYear < 90 || rocYear > 150) {
				alert('請輸入有效的民國年分（例如：115）');
				return;
			}
			this.addYearLoading = true;
			try {
				const res = await axios.post(`/api/Account/createYear?year=${rocYear}`);
				if (res.data.status) {
					this.addYearDialog = false;
					await this.loadYearList();
					this.$store.commit('setSelectedYear', rocYear);
				} else {
					alert(res.data.message || '新增年分失敗');
				}
			} catch (err) {
				alert(err.response?.data?.message || '新增年分失敗');
			} finally {
				this.addYearLoading = false;
			}
		},
	},
	created() {
		//已登入過
		this.refreshState();
		// if (this.name && this.role === 1) {
		// 	this.loadYearList();
		// }
		//新登入，刷新狀態
		bus.$on('login', () => {
			this.refreshState();
		});
	},
};
</script>

<style>
.input {
	border-right: 1px solid #aaa;
	padding: 5px;
	width: 100%;
}
.bdr {
	border-radius: 5px;
	border: 1px solid #aaa;
}
.rect {
	width: 100px;
	height: 30px;
}
.psf {
	position: fixed;
	right: 10px;
	bottom: 10px;
}
.rel {
	position: relative;
}
.abs {
	position: absolute;
}
.wh100p {
	width: 100%;
	height: 100%;
}
.vh50 {
	height: 50vh;
}
.w120 {
	width: 120px;
}
.h50 {
	height: 50px;
}
.table {
	width: 100%;
	border-collapse: collapse;
}
.table td {
	border: 1px solid #eee;
	padding: 4px 8px;
	white-space: nowrap; 
}
.ml--2 {
	margin-left: -20px;
}
.my-event {
	overflow: hidden;
	text-overflow: ellipsis;
	border-radius: 2px;
	color: #ffffff;
	width: 100%;
	font-size: 12px;
	padding: 3px;
	cursor: pointer;
	margin-bottom: 1px;
}
.psf-corner {
	position: fixed;
	width: 300px;
	height: 300px;
	left: 0;
	bottom: 0;
	border-radius: 0 300px 0 0;
	color: #fff;
	transform: scale(0.2);
	transition: 1s;
	transform-origin: bottom left;
}
.psf-corner:hover {
	transform: scale(1);
}
.center-text {
	position: absolute;
	top: 50%;
	transform: translateY(-50%);
	margin: 20px;
}
.overflow-x {
	overflow-x: scroll;
}
.overflow-y {
	overflow-y: auto;
}
.input {
	border-right: 1px solid #aaa;
	padding: 5px;
	width: 100%;
}
.badge {
	padding-right: 5px;
	padding-left: 5px;
	margin-right: 5px;
	border-radius: 5px;
	color: #fff;
	display: inline-block;
}
.psf-center {
	position: fixed;
	width: 300px;
	text-align: center;
	left: 50%;
	top: 50%;
	transform: translate(-50%, -50%);
	animation: blink 5s infinite;
}
.v-expansion-panel-content__wrap {
	padding: 0 !important;
}
.v-expansion-panel-header {
	font-weight: bold;
	color: #009688 ;
}
.v-expansion-panel-header--active {
	min-height: auto !important;
}
.section-block {
    margin-bottom: 10px;
    border-top: 1px;
    padding-top: 10px;
}
.section-title {
    font-size: 1rem;
    font-weight: 600;
    margin-bottom: 12px;
    color: #bd1313;
}
.section-divider {
    height: 16px;
    background-color: #FFF3E0;
    margin: 0 -16px;
}
@keyframes blink {
	0%,
	100% {
		opacity: 0;
	}
	50% {
		opacity: 1;
	}
}
</style>
